import { Modal } from "antd";
import CreateUserForm from "./CreateUserForm";

const EditUser = ({ user, isOpen, closeModal }) => {
  return (
    <Modal
      title={null}
      width="500px"
      open={isOpen}
      onCancel={closeModal}
      className="delete-popup tw-overflow-hidden"
      footer={false}
      destroyOnClose={true}
      centered
    >
      <CreateUserForm initialValues={user} closeModal={closeModal} />
    </Modal>
  );
};

export default EditUser;
